import { Dialog } from '@mui/material';
import { isEmpty } from 'ramda';
import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { MEDIA_STATUS } from '../consts';
import messages from '../intl/messages';
import { getFaceUrl, getIdUrl } from '../store/model/selectors';
import MediaAccessDeniedAlert from './MediaAccessDeniedAlert';

const useStyles = makeStyles()((theme) => ({
	root: {
		width: '100%',
		height: '471px',
		'& > div': {
			width: '100%',
			display: 'flex',
			alignItems: 'stretch',
			justifyContent: 'center',
			padding: '20px 0',
			gap: '2%',
		},
		'& > div > *': {
			flex: 1,
			flexBasis: 0,
			border: '1px solid black',
			boxSizing: 'border-box',
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			maxWidth: '49%',
			minHeight: '280px',
		},
		'& div img': {
			height: 'auto',
			border: 'none',
		},
	},
}));

const NoPhoto = ({ id }) => (
	<div className="noPhoto">
		<FormattedMessage {...messages[id ? 'idPhotoNotAvailable' : 'facePhotoNotAvailable']} />
	</div>
);

const AccessDenied = () => (
	<div className="noPhoto">
		<MediaAccessDeniedAlert />
	</div>
);

const preventContextMenu = (e) => e.preventDefault();

const Photo = ({ alt, imageRef, isId, onZoom, url }) => {
	if (url === MEDIA_STATUS.FORBIDDEN) return <AccessDenied />;

	if (isEmpty(url)) return <NoPhoto id={isId} />;

	return (
		<img
			draggable="false"
			ref={imageRef}
			alt={alt}
			src={url}
			onClick={() => onZoom(url)}
			onContextMenu={preventContextMenu}
			style={{ cursor: 'zoom-in' }}
		/>
	);
};

const Identification = () => {
	const { classes } = useStyles();
	const idUrl = useSelector(getIdUrl);
	const faceUrl = useSelector(getFaceUrl);
	const [image, setImage] = useState(null);
	const idRef = useRef();
	const faceRef = useRef();

	return (
		<div className={`${classes.root}`}>
			<div>
				{image && (
					<Dialog maxWidth={'xl'} open={true} onClick={() => setImage(null)}>
						<img
							draggable="false"
							src={image}
							alt=""
							onContextMenu={preventContextMenu}
							style={{ cursor: 'zoom-out' }}
						/>
					</Dialog>
				)}
				<Photo alt="Id" imageRef={idRef} isId url={idUrl} onZoom={setImage} />
				<Photo alt="Face" imageRef={faceRef} url={faceUrl} onZoom={setImage} />
			</div>
		</div>
	);
};

export default Identification;
